import React from 'react'
import PropTypes from 'prop-types'

const SECONDARY_BTN_CLASS = 'btn btn-outline-light text-dark border border-muted'

const ModalFooter = ({
  step,
  canGoNext,
  onBack,
  onNext,
  onClose,
  onImport
}) => {
  switch (step) {
  case 1:
    return (
      <>
        <button className={SECONDARY_BTN_CLASS} type="button" onClick={onClose}>
          Annuler
        </button>
        <button className="btn btn-success" type="button" onClick={onNext}>
          Suivant
        </button>
      </>
    )
  case 2:
    return (
      <>
        <button className={SECONDARY_BTN_CLASS} type="button" onClick={onBack}>
          Retour
        </button>
        <button
          className={`btn ${canGoNext ? 'btn-success' : 'btn-secondary'}`}
          disabled={!canGoNext}
          type="button"
          onClick={onNext}
        >
          Suivant
        </button>
      </>
    )
  case 3:
    return (
      <>
        <button className={SECONDARY_BTN_CLASS} type="button" onClick={onBack}>
          Retour
        </button>
        <button className="btn btn-success" type="button" onClick={onImport}>
          Importer
        </button>
      </>
    )
  default:
    return null
  }
}

ModalFooter.propTypes = {
  canGoNext: PropTypes.bool,
  onBack: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onImport: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  step: PropTypes.number.isRequired
}

ModalFooter.defaultProps = {
  canGoNext: false
}

export default ModalFooter
